import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { appSettings } from '../../environments/app-settings';
import { disableErrorHandler } from '../http/error.interceptor';

/**
 * Application initialization state.
 */
export interface AppState {
  /**
   * A flag that shows if the application was initialized already.
   */
  initialized: boolean;
  /**
   * Application initialization information.
   */
  info: string;
}

@Injectable({ providedIn: 'root' })
export class AppStateService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${appSettings.api.url}appState`;

  public getState(): Observable<AppState | null> {
    return this.http.get<AppState>(this.baseUrl, { context: disableErrorHandler() })
      .pipe(catchError(_ => of(null)));
  }
}
